export enum RequestError
{
    LOGIN_GENERIC                         =   -200000,
    LOGIN_WRONG_USERNAME                  =   -200001,
    LOGIN_WRONG_PASSWORD                  =   -200002,
    LOGIN_PASSWORD_CHANGE_REQUIRED        =   -200003,
    LOGIN_OPERATOR_NOT_AUTHORIZED         =   -200004,
    LOGIN_OPERATOR_ALREDY_LOGGED          =   -200005,

    LOGOUT_GENERIC                        =   -200100,
    LOGOUT_USER_NOT_ALLOWED               =   -200101,

    PASSWORD_CHANGE_GENERIC               =   -200200,
    PASSWORD_CHANGE_SAMEPASSWORD          =   -200201,
    PASSWORD_CHANGE_WRONG_PASSWORD        =   -200202,

    DEVICE_CALENDAR_U_GENERIC             =   -200500,
    DEVICE_CALENDAR_U_INVALID_OPEN_TIME   =   -200501,
    DEVICE_CALENDAR_U_INVALID_CLOSE_TIME  =   -200502,
    DEVICE_CALENDAR_U_TIME_SUPERIMPOSED   =   -200503,

    DEVICE_CALENDAR_D_GENERIC = -200600,

    DEVICE_CALENDAR_S_GENERIC = -200700,

    SERVICE_CALENDAR_U_GENERIC            =   -200800,
    SERVICE_CALENDAR_U_INVALID_OPEN_TIME  =   -200801,
    SERVICE_CALENDAR_U_INVALID_CLOSE_TIME =   -200802,
    SERVICE_CALENDAR_U_TIME_SUPERIMPOSED  =   -200804,

    SERVICE_CALENDAR_D_GENERIC            =   -200900,

    SERVICE_CALENDAR_S_GENERIC            =   -201000,

    CALLMODE_L_GENERIC                    =   -201100,

    CALLMODE_U_GENERIC                    =   -201200,

    COUNTER_SERVICE_L_GENERIC             =   -201300,

    COUNTER_SERVICE_SET_GENERIC           =   -201400,

    COUNTER_SERVICE_UNSET_GENERIC         =   -201500,

    OPERATOR_ASSIGN_INVALID_LOGIN_ID = -201801,

    OPERATOR_UNASSIGN_INVALID_LOGIN_ID = -201901,

    DEVICE_OPERATOR_INVALID_LOGIN_ID = -202001,

    MESSAGE_INVALID_MESSAGE_ID = -202201,

    MESSAGE_DELETE_INVALID_MESSAGE_ID = -202301,

    MESSAGE_INVALID_DATE_SIZE = -202501,

    MESSAGE_UPDATE_INVALID_MESSAGE_ID = -202601,
    MESSAGE_UPDATE_INVALID_DATE_SIZE  = -202602,

    STATISTIC_UNAUTH_USER              = -203701,
    STATISTIC_UNAUTH_USER_RESOURCE     = -203702,
    STATISTIC_WRONG_DATE_FORMAT        = -203703,
    STATISTIC_INVALID_DATE_TO          = -203704,
    STATISTIC_INVALID_SC               = -203705,
    STATISTIC_INVALID_DT               = -203706,
    STATISTIC_INVALID_PERIOD           = -203707,
    STATISTIC_SPECIFY_JUST_SITE_OR_ORG = -203708,

    SLOT_INVALID_DATE_IN        = -204101,

    SLOT_DAY_INVALID_DATE_IN      = -204201,
    SLOT_LESS_CURRENT_DATE        = -204202,

    SLOT_DAY_INVALID_TYPE    = -204203,
    SLOT_DAY_NOT_FOUND       = -204204,

    SLOT_BOOK_NOT_EXIST                     = -204301,
    SLOT_BOOK_LESS_CURRENT_DATE             = -204302,
    SLOT_BOOK_ONLY_TODAY                    = -204303,
    SLOT_TIME_JUST_PASSED                   = -204304,
    SLOT_PRENOTATION_EXIST                  = -204305,
    SLOT_TIME_UNAVAILABLE                   = -204306,

    SLOT_UPDATE_BOOK_NOT_EXIST              = -204401,
    SLOT_INVALID_ID                         = -204402,

    SLOT_DELETE_BOOK_NOT_EXIST              = -204501,

    SLOT_TIME_CREATE_INVALID_DATE_IN        = -204601,
    SLOT_TIME_CREATE_LESS_CURRENT_DATE      = -204602,
    SLOT_TIME_CREATE_INVALID_TIME_ID        = -204603,
    SLOT_TIME_CREATE_DUPLICATED_SLOT        = -204605,

    SLOT_TIME_UPDATE_INVALID_DATE_IN        = -206001,
    SLOT_TIME_UPDATE_LESS_CURRENT_DATE      = -206002,
    SLOT_TIME_UPDATE_INVALID_TIME_ID        = -206003,
    SLOT_TIME_UPDATE_DUPLICATED_SLOT        = -206005,
    SLOT_TIME_UPDATE_ALREADY_BOOKED         = -206006,

    SLOT_TIME_DELETE_INVALID_DATE_IN        = -204701,
    SLOT_TIME_DELETE_LESS_CURRENT_DATE      = -204702,
    SLOT_TIME_DELETE_INVALID_TIME_ID        = -204703,
    SLOT_TIME_DELETE_BOOKABLE_DAY_NOT_EXIST = -204704,
    SLOT_TIME_DELETE_BOOKED                 = -204705,

    BOOK_KEY_INVALID = -300001,
    BOOK_MODE_INVALID = -300002,
    BOOK_USER_INVALID = -300003,
    BOOK_SLOT_INVALID = -300010,
    BOOK_PRENOTABILITY_INVALID = -300020,
    BOOK_TIME_ELAPSED = -300022,
    BOOK_ALREADY_BOOKED = -300030,



    DEVICE_ACTIVATION_NOT_EXIST = -999996,
    USER_NOT_ALLOWED            = -999998,
    TOKEN_HAS_EXPIRED           = -999999
}

export function isRequestError( value: any )
{
    return Object.values(RequestError).includes(value)
}
